import DownloadIcon from '@mui/icons-material/Download';
import Button from '@mui/material/Button';
import React from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logo from '../assets/images/finaculator1.png';
import addWatermark from './watermark';
import ReactGA from 'react-ga4'
import { useState } from "react";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

interface SIPPDFGeneratorProps {
  monthlyInvestment: string;
  rate: string;
  period: string;
  totalInvestment: number | null;
  interestEarned: number | null;
  totalAmount: number | null;
  chartTotalAmount: number[];
  chartTotalInterest: number[];
  currencySymbol: string;
  isCalculated?:boolean,

}

const SIPPDFGenerator: React.FC<SIPPDFGeneratorProps> = ({
  monthlyInvestment,
  rate,
  period,
  totalInvestment,
  interestEarned,
  totalAmount,
  chartTotalAmount,
  chartTotalInterest,
  isCalculated
}) => {

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const generatePDF = () => {
    ReactGA.event({ 'category': 'SIP PDF ', 'action': 'SIP PDF Button', 'label': 'SIP PDF' })

    if (!isCalculated) {
      setSnackbarMessage("Please calculate the values before downloading the PDF.");
      setSnackbarOpen(true);
      return;
    }
   

    if (  !monthlyInvestment ||
      !rate ||
      !period ||
      !totalInvestment ||
      !interestEarned ||
      !totalAmount ||
      !chartTotalAmount.length ||
      !chartTotalInterest.length ||
      !isCalculated) {
      setSnackbarMessage("Please ensure all fields are filled before downloading the PDF.");
      setSnackbarOpen(true);
      return;
    }
    

    const doc = new jsPDF();
    const watermarkWidth = 100;
    const watermarkHeight = 100;
    doc.setFontSize(20);
    doc.text('Systematic Investment Plan Calculator', 14, 20);

    const tableData = [
      ['Monthly Investment', `${monthlyInvestment}`],
      ['Expected Annual Return Rate', `${rate}%`],
      ['Investment Period', `${period} Years`],
      ['Total Investment', `${totalInvestment ? Math.ceil(totalInvestment) : ''}`],
      ['Total Interest Earned', `${interestEarned ? Math.ceil(interestEarned) : ''}`],
      ['Total Amount at Maturity', ` ${totalAmount ? Math.ceil(totalAmount) : ''}`],
    ];

    autoTable(doc, {
      head: [['Description', 'Value']],
      body: tableData,
      startY: 40,
      theme: 'grid',
    });

    const chartTableData = chartTotalAmount.map((amount, index) => ({
      Year: `Year ${index + 1}`,
      'Total Amount': `${Math.ceil(amount)}`,
      'Total Interest': `${Math.ceil(chartTotalInterest[index])}`,
    }));

    autoTable(doc, {
      head: [['Year', 'Total Amount', 'Total Interest']],
      body: chartTableData.map(item => [item.Year, item['Total Amount'], item['Total Interest']]),
      startY: doc.autoTable.previous.finalY + 10,
      theme: 'grid',
      styles:{halign:'center'}
    });
    addWatermark(doc, logo, watermarkWidth, watermarkHeight);
    const img = new Image();
    img.src = logo;
    img.onload = () => {
      const now = new Date();
      const padZero = (num: string | number) => ("0" + num).slice(-2);
      const formattedDate = `${now.getFullYear()}-${padZero(now.getMonth() + 1)}-${padZero(now.getDate())}`;
      const formattedTime = `${padZero(now.getHours())}-${padZero(now.getMinutes())}-${padZero(now.getSeconds())}`;
      const timestamp = `${formattedDate}_${formattedTime}`;
      const fileName = `finaculator_sip_calculator_${timestamp}.pdf`;
      doc.save(fileName);
    };
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
      <Button
        variant="contained"
        color="success"
        onClick={generatePDF}
        startIcon={<DownloadIcon />}
        style={{ marginTop: -70 }}
      >
        Download PDF
      </Button>


      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }} 
      >
        <MuiAlert onClose={handleSnackbarClose} severity="warning" sx={{ width: '100%' }}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default SIPPDFGenerator;
